import React from 'react';
import { FaTaxi, FaPlane, FaHospitalUser, FaMoneyBillWave, FaUsers } from 'react-icons/fa';
import ScrollToTop from '../components/ScrollToTop';
import '../styles/Home.css';
import bgServices from '../assets/bg-services.jpg';

const servicesList = [
  { icon: <FaTaxi />, label: 'Trajets locaux et longues distances' },
  { icon: <FaPlane />, label: 'Transferts aéroport (Bâle‑Mulhouse, Dole, Strasbourg...)' },
  { icon: <FaHospitalUser />, label: 'Transport médical conventionné (sur réservation)' },
  { icon: <FaMoneyBillWave />, label: 'Paiement CB, espèces' },
  { icon: <FaUsers />, label: 'Transport familles, enfants, PMR' },
];

const Home = () => (
  <main className="home-wrapper">

    {/* Hero Section */}
    <header
      className="hero-parallax"
      style={{
        backgroundImage: 'url(/images/montbeliard.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      role="banner"
      aria-label="Bannière Asprotaxi Montbéliard Sainte-Suzanne"
    >
      <div className="overlay-parallax">
        <img src="/logo.png" alt="Logo Asprotaxi" className="hero-logo" />
        <h1>Taxi Asprotaxi</h1>
        <h2>Montbéliard & Sainte-Suzanne</h2>
        <p>Professionnalisme • Confort • Ponctualité</p>
      </div>
    </header>

    {/* Services Section */}
    <section
      id="services"
      className="services section-container"
      style={{
        backgroundImage: `url(${bgServices})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        color: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
      aria-label="Liste des services proposés par Asprotaxi"
    >
      {/* Overlay sombre pour lisibilité */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 0,
      }} />
      <div style={{ position: 'relative', zIndex: 1, padding: '2rem' }}>
        <h2>Nos Services</h2>
        <ul className="services-list">
          {servicesList.map(({ icon, label }, i) => (
            <li key={i} className="service-item">
              <span className="service-icon" aria-hidden="true">{icon}</span>
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* Communes Section */}
    <section className="localisation section-container" aria-label="Communes de stationnement">
      <h2>Communes de stationnement</h2>
      <div className="localisation-images">
        <figure>
          <img src="/images/montbeliard.jpg" alt="Vue touristique de Montbéliard" />
          <figcaption>Montbéliard</figcaption>
        </figure>
        <figure>
          <img src="/images/sainte-suzanne.jpg" alt="Vue touristique de Sainte-Suzanne" />
          <figcaption>Sainte-Suzanne</figcaption>
        </figure>
      </div>
    </section>

    {/* Contact Section */}
    <section id="contact" className="contact-rapide section-container" aria-label="Contact rapide">
      <h2>Besoin d’un taxi rapidement ?</h2>
      <a href="tel:+33777685938" className="btn-secondary" aria-label="Téléphoner à Asprotaxi">
        📞 Appeler maintenant
      </a>
    </section>

    <ScrollToTop />
  </main>
);

export default Home;

